module.exports = __webpack_public_path__ + "static/media/hints.6abde7ef.svg";